var map = {
	"./allura_cdc/logo.svg": "05ac",
	"./bau/logo.svg": "fc09",
	"./home_design/logo.svg": "3035",
	"./midas_cdc/logo.svg": "1ec2",
	"./millennium_cdc/logo.svg": "8050",
	"./omnilink/logo.svg": "b37a",
	"./romanzza/logo.svg": "01e1",
	"./size_multiplo/logo.svg": "ba42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2426";